import "./PgPubNotFound.css";

const PgPubNotFound = () => {
  return (
    <main className="pub-not-found-page">
      <div className="pub-not-found-page__code">
        404
      </div>

      <h1 className="pub-not-found-page__title">
        Page Not Found
      </h1>

      <p className="pub-not-found-page__message">
        Sorry, the page you're looking for doesn't exist, may have been
        moved, or is temporarily unavailable.
      </p>

      <a
        className="pub-not-found-page__home-link"
        href="/"
      >
        Return Home
      </a>
    </main>
  );
};

export default PgPubNotFound;